"use client";

import styled from "styled-components";
import Icon from "../icon";

//Types
interface ButtonProps {
  $widthFull?: boolean;
  $variant?: "default" | "danger" | "warning" | "success" | undefined;
  $small?: boolean;
}

const variantStyles = {
  default: `
        background: transparent;
        color: var(--textLight);
        border: 1px solid var(--textLight);

        &:hover {
            background: rgba(75, 85, 99, 0.1);
        }
    `,
  danger: `
        background: var(--red);
        color: var(--lightRed);

        &:hover {
            background: var(--red);
        }
    `,
  warning: `
        background: var(--infoSystem);
        color: var(--black);

        &:hover {
            background: var(--infoSystem);
        }
    `,
  success: `
        background: var(--primarySystem100);
        color: var(--white);

        &:hover {
            background: var(--primarySystem400);
        }
    `,
  green: `
        background: var(--green);
        color: var(--white);
        &:hover {
            background: var(--greenDark); 
        }
    `,
};

export const Button = styled.button<ButtonProps>`
  font-family: "Roboto Medium";
  font-size: 15px;
  background: var(--primarySystem100);
  padding: 0 1rem;
  height: 2.8em;
  color: var(--white);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: calc(0.625rem - 2px);
  border: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  &:hover {
    background: var(--primarySystem400);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
    transform: none;
  }

  width: ${({ $widthFull }) => ($widthFull ? "100%" : "auto")};

  ${({ $variant = "default" }) => variantStyles[$variant]}

  ${({ $small }) =>
    $small &&
    `
    padding: 0 0.75rem;
    height: 2.5em;
    font-size: 13px;

    svg{
        width: 15px;
        height: 15px;
    }
`}
`;

export const IconComponent = styled(Icon)`
  svg {
    max-width: 20px !important;
    max-height: 20px !important;

    path {
      fill: var(--titleColor);
    }
  }
`;

export const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
